export const LIVE_CLASSROOM_TRAINING_URL =
    'https://skillbuilder.aws/category/style/live-classroom-training';
export const SKILLBUILDER_URL = 'https://explore.skillbuilder.aws/learn';
export const CERTIFICATION_URL = 'https://aws.amazon.com/certification';
